/*
	This mixin acts as a bridge between the new Vue stack, which will gradually be implemented in PdB new features,
	and old vanilla JS scripts and libraries.
*/

import Vue from 'vue'
import store from '@store'

import { script } from '@base_js/script'


const LegacyBridgeMixin = {
  mounted() {
    $(document).on('vue-loaded', function () {

    	script()
	  });

  	this.$nextTick(function () {
      $(document).trigger('vue-loaded');
    })
  }
};

export default LegacyBridgeMixin;
